import axios from "axios";
import { BASEURL } from "../../constants";
import { jwtDecode } from "jwt-decode";
import { useRef, useState, useEffect } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import StudentCourseList from "./StudentCourseList";

const StudentMyCourses = () => {

    const [studentCourses, setStudentCourses] = useState([]);
    const [inProgress, setInProgress] = useState([])
    const [notStarted, setNotStarted] = useState([])
    const [completed, setCompleted] = useState([])

    const studentCoursesRef = useRef(null);
    const [coverImages, setCoverImages] = useState({});
    const [searchTerm, setSearchTerm] = useState(""); // Search term state
    const token = localStorage.getItem('auth');
    const { activeTab } = useParams()

    const decoded = jwtDecode(token);
    const userRole = decoded.role;
    const userId = decoded.user_id;
    const schoolId = decoded.org_id;
    const classId = decoded.class_id;

    const navigate = useNavigate();
    const debounce = (func, delay) => {
        let timer;

        return (...args) => {
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => {
                func(...args)
            }, delay)
        }
    }

    const debouncedSearch = debounce(handleSearch, 400);


    function handleSearch(e) {
        let searchString = e.target.value;
        if (e.target.value) {
            const newStudentCourses = studentCoursesRef.current.filter((course) => (
                course.course_name.toLowerCase().includes(searchString.toLowerCase()) || course.subject_name.toLowerCase().includes(searchString.toLowerCase())
            ))
            setStudentCourses(newStudentCourses);
        } else {
            setStudentCourses(studentCoursesRef.current);
        }
    }

    useEffect(() => {
        axios.get(`${BASEURL}/api/get-student-courses`, {
            params: {
                studentId: userId,
                schoolId: schoolId,
                classId: classId
            }
        }).then((response) => {

            studentCoursesRef.current = [...response.data];
            let inProgressArray = [];
            let notStartedArray = [];
            let completedArray = [];
            const courses = response.data;
            courses.forEach((course) => {
                

                if (course.course_completion_percentage === 0) {
                    notStartedArray.push(course);
                }

                if (course.course_completion_percentage > 0) {
                    inProgressArray.push(course);
                }

                if (course.course_completion_percentage === 100) {
                    completedArray.push(course);
                }
            })
            
            setStudentCourses(response.data);
            setInProgress(inProgressArray)
            setNotStarted(notStartedArray)
            setCompleted(completedArray)

        })
    }, [])

    return (
        <div className="w-full">

            <div className='flex justify-between px-6 pt-6 pb-4'>
                <div className="flex items-center overflow-x-auto whitespace-nowrap">
                    <p className="text-2xl text-slate-900 font-bold cursor-pointer">
                        My Courses
                    </p>
                </div>
            </div>
            <div class="flex overflow-x-auto mb-4 mx-6 overflow-y-hidden border-b border-gray-200 whitespace-nowrap">
                <button className={`inline-flex gap-2 px-4 py-2 items-center h-10 -mb-px text-sm  text-center ${activeTab === 'all' ? 'text-customPrimaryPurple bg-transparent border-b-[3px] font-bold border-customPrimaryPurple' : 'text-gray-700 font-normal bg-transparent border-b-2 border-transparent'
                    } sm:text-base whitespace-nowrap cursor-pointer focus:outline-none`}
                    onClick={() => navigate('/student/myCourses/all')}>
                    <div>
                        All
                    </div>
                    <div className="text-xs px-2 py-1 bg-borderColor rounded-md">
                        {
                            studentCourses.length
                        }
                    </div>
                </button>
                <button
                    className={`flex gap-2 px-4 py-2 items-center h-10  -mb-px text-sm  text-center ${activeTab === 'inProgress' ? 'text-customPrimaryPurple bg-transparent border-b-[3px] font-bold border-customPrimaryPurple' : 'text-gray-700 bg-transparent border-b-2 font-normal border-transparent'
                        } sm:text-base whitespace-nowrap cursor-pointer focus:outline-none`}
                    onClick={() => navigate('/student/myCourses/inProgress')}>
                    <div className="font-inter">
                        In progress
                    </div>
                    <div className="text-xs px-2 py-1 bg-borderColor rounded-md">
                        {
                            inProgress.length
                        }
                    </div>
                </button>
                <button
                    className={`flex gap-2 px-4 py-2 items-center h-10  -mb-px text-sm text-center ${activeTab === 'notStarted' ? 'text-customPrimaryPurple bg-transparent border-b-[3px] font-bold border-customPrimaryPurple' : 'text-gray-700 bg-transparent font-normal border-b-2 border-transparent'
                        } sm:text-base whitespace-nowrap cursor-pointer focus:outline-none`}
                    onClick={() => navigate('/student/myCourses/notStarted')}>
                    <div>
                        Not started
                    </div>
                    <div className="text-xs px-2 py-1 bg-borderColor rounded-md">
                        {
                            notStarted.length
                        }
                    </div>
                </button>
                <button
                    className={`inline-flex gap-2 px-4 py-2 items-center h-10 -mb-px text-sm text-center ${activeTab === 'completed' ? 'text-customPrimaryPurple bg-transparent border-b-[3px] font-bold border-customPrimaryPurple' : 'text-gray-700 font-normal bg-transparent border-b-2 border-transparent'
                        } sm:text-base whitespace-nowrap cursor-pointer focus:outline-none`}
                    onClick={() => navigate('/student/myCourses/completed')}>
                    <div>
                        Completed
                    </div>
                    <div className="text-xs px-2 py-1 bg-borderColor rounded-md">
                        {
                            completed.length
                        }
                    </div>
                </button>
            </div>
            <div className="mx-auto px-6">
                {
                    activeTab === 'all' && (
                        <StudentCourseList searchTerm={searchTerm} courseArray={studentCourses} />
                    )
                }
                {
                    activeTab === 'inProgress' && (
                        <StudentCourseList searchTerm={searchTerm} courseArray={inProgress} />
                    )
                }
                {
                    activeTab === 'notStarted' && (
                        <StudentCourseList searchTerm={searchTerm} courseArray={notStarted} />
                    )
                }
                {
                    activeTab === 'completed' && (
                        <StudentCourseList searchTerm={searchTerm} courseArray={completed} />
                    )
                }
            </div>
        </div>

    );
}

export default StudentMyCourses;